import { HEX_477FBA, HEX_545A61, HEX_66AAFF, HEX_ADB5C7, HEX_E2E8F0 } from '@tanium/colors';
import {
  BackgroundFormInput,
  Border2,
  defineColor,
  InputFocus,
  StatusNegative,
  Text1,
  Text3,
} from '@tanium/react-theme-definition';

export const Fill = BackgroundFormInput;
export const FillDisabled = defineColor([HEX_E2E8F0, HEX_545A61]);

export const Text = Text1;
export const TextDisabled = Text3;
export const PlaceholderText = Text3;

export const Border = Border2;
export const BorderFocus = defineColor([HEX_477FBA, HEX_66AAFF]);
export const BorderInvalid = StatusNegative;
export const BorderDisabled = defineColor([HEX_ADB5C7, HEX_545A61]);

export const ShadowFocus = InputFocus;
